(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["circle_features"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".Circles_Features");
  const slides = container.querySelectorAll(".Circle_Feature__Container");
  const prev = document.querySelector(".circle-prev");
  const next = document.querySelector(".circle-next");

  let index = 0;

  function showSlide(i) {
    slides.forEach((slide, idx) => {
      slide.classList.remove("active");
    });
    slides[i].classList.add("active");
  }

  if (slides.length > 0) {
    showSlide(index);

    prev.addEventListener("click", () => {
      index = (index - 1 + slides.length) % slides.length;
      showSlide(index);
    });

    next.addEventListener("click", () => {
      index = (index + 1) % slides.length;
      showSlide(index);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection_nav"] && !Shopify.designMode) return;
  try {
    
  
  (() => {
    class ScrollButtons extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      init() {
        const buttons = this.querySelectorAll('.scroll-button');
        const container = this.querySelector('.scroll-buttons__container');

        // Scroll automatique vers le bouton actif au chargement
        const activeBtn = container.querySelector('.scroll-button.active');
        if (activeBtn) {
          activeBtn.scrollIntoView({
            behavior: 'auto',
            block: 'nearest',
            inline: 'center'
          });
        }

        let isDragging = false;
        let startX = 0;
        let scrollLeft = 0;
        let dragged = false;

        container.addEventListener('mousedown', (e) => {
          isDragging = true;
          dragged = false;
          startX = e.pageX - container.offsetLeft;
          scrollLeft = container.scrollLeft;
          container.style.cursor = 'grabbing';
        });

        container.addEventListener('mouseleave', () => {
          isDragging = false;
          container.style.cursor = 'grab';
        });

        container.addEventListener('mouseup', () => {
          isDragging = false;
          setTimeout(() => {
            dragged = false;
          }, 50);
          container.style.cursor = 'grab';
        });

        container.addEventListener('mousemove', (e) => {
          if (!isDragging) return;
          const x = e.pageX - container.offsetLeft;
          const walk = x - startX;
          if (Math.abs(walk) > 5) dragged = true;
          container.scrollLeft = scrollLeft - walk;
        });

        buttons.forEach((button) => {
          button.addEventListener('click', (e) => {
            if (dragged) {
              e.preventDefault();
              return;
            }
            buttons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');
          });
        });
      }
    }

    customElements.define('scroll-buttons', ScrollButtons);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["open_omnisend_modal"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const KEY = 'omnisend_popup_shown';
    const FORM_ID = '68a1f571d1e73f776385a9de';

    // 1) Ouvrir via le bouton
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.Open__Omnisend__Popup');
      if (!btn) return;
      const formId = btn.getAttribute('data-omnisend-form-id') || FORM_ID;
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', formId]);
    });

    
  })();

  } catch(e) { console.error(e); }
})();
})();
